import {
  InstantSearch,
  InfiniteHits,
  HitsPerPage,
  Pagination,
} from "react-instantsearch";
import { VehicleCard } from "../vehicle/card";
import { instantSearchClient } from "../../meiliseach/client";
import MeilisearchAutocomplete from "./Autocomplete";
import { MeiliSearchVehicleType, SearchHit } from "../../types/Vehicle.types";
import {
  loadFacetValues,
  mapAttributeToPortuguese,
  stateToUrl,
  urlToState,
} from "../../utils/filter";
import { CustomStats } from "./CustomStats";
import { history } from "instantsearch.js/es/lib/routers";
import { FilterItems } from "./FilterItems";
import { useEffect, useState } from "react";

export const Filter = () => {
  const [facetsLoaded, setFacetsLoaded] = useState(false);

  useEffect(() => {
    const initialize = async () => {
      await loadFacetValues();
      setFacetsLoaded(true);
    };

    initialize();
  }, []);

  if (!facetsLoaded) {
    return <div>Carregando filtros...</div>;
  }

  const router = history({
    cleanUrlOnDispose: false,
  });

  const routing = {
    router: router,
    stateMapping: {
      stateToRoute: stateToUrl(mapAttributeToPortuguese),
      routeToState: urlToState,
    },
  };

  return (
    <div>
      <InstantSearch
        indexName="vehicles"
        searchClient={instantSearchClient.searchClient}
        // @ts-ignore
        routing={routing}
        future={{
          preserveSharedStateOnUnmount: true,
        }}
      >
        <h1 className="mb-16 text-2xl lg:text-5xl tracking-tighter font-bold text-center">
          Carros novos e seminovos
        </h1>

        <div className="flex flex-col md:flex-row gap-6 justify-center">
          <FilterItems />

          <div className="md:w-[65%] w-full">
            <MeilisearchAutocomplete />
            <CustomStats />

            <InfiniteHits
              showPrevious={false}
              hitComponent={({
                hit,
              }: {
                hit: SearchHit<MeiliSearchVehicleType>;
              }) => {
                return (
                  <VehicleCard
                    key={"infinit-hits" + hit.id + hit.model + hit.version}
                    hit={hit}
                  />
                );
              }}
            />

            <div className="flex gap-4 w-full items-center justify-center mt-4">
              <Pagination />
              <HitsPerPage
                items={[10, 20, 30, 40, 50, 100, 200].map((value) => ({
                  label: `${value}`,
                  value,
                  default: value === 50,
                }))}
              />
            </div>
          </div>
        </div>
      </InstantSearch>
    </div>
  );
};
